<template>
    <section class="full-background-section">
      <h2 class="top-centered-text">NUEVA CREMA DENTAL <br> COLGATE PERIOGARD<sup>®</sup></h2>
      
      <!-- Imagen al lado derecho (Diente.png) y las 3 imágenes encima -->
      <img src="../assets/periogard/Diente.png" alt="Logo Secundario" class="right-image" />
      <img src="../assets/periogard/Fluoruro.png" alt="Fluoruro" class="right-image right-image-1" />
      <img src="../assets/periogard/Fosfato.png" alt="Fosfato" class="right-image right-image-2" />
      <img src="../assets/periogard/Iones .png" alt="Iones" class="right-image right-image-3" />
  
      <!-- Texto a la izquierda -->
      <h2 class="left-text">
        EXCLUSIVA TECNOLOGÍA PARA <br>  
        <span class="bold-text">AYUDAR A CONTROLAR</span> <br> 
        SALUD DE LAS ENCÍAS
      </h2>
  
      <!-- Imagen al lado izquierdo, centrada verticalmente -->
      <img src="../assets/periogard/Crema 1.png" alt="Imagen Izquierda" class="left-image" />
  
      <!-- Imagen al lado derecho, centrada verticalmente -->
      <img src="../assets/periogard/Texto 3_1.png" alt="Imagen Derecha" class="right-side-image" />
  
      <!-- Nueva imagen debajo de Texto 3_1.png -->
      <img src="../assets/periogard/banner.png" alt="Imagen Inferior" class="bottom-right-image" />
  
      <!-- Imagen centrada horizontalmente tocando el borde inferior -->
      <img src="../assets/periogard/crema 2.png" alt="Imagen Inferior Centrada" class="bottom-centered-image" />
    </section>
  </template>
  
  <script setup>
  import { onMounted } from "vue";
  import { gsap } from "gsap";
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  
  // Registra los plugins
  gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);
  
  onMounted(() => {
    gsap.to(".bottom-right-image", {
      motionPath: {
        path: [
          { x: 50, y: -30 },
          { x: -30, y: -50 },
          { x: 0, y: 0 }, // Regresa suavemente
        ],
        curviness: 1.2, // Curva más ligera
        autoRotate: false,
      },
      duration: 40, // Extra lento
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".bottom-right-image",
        start: "top bottom",
        end: "center center",
        scrub: 8, // Súper suave con el scroll
      },
    });
  
    gsap.to(".bottom-centered-image", {
      motionPath: {
        path: [
          { x: -60, y: -40 },
          { x: 40, y: -60 },
          { x: 0, y: 0 }, // Vuelve a su posición original
        ],
        curviness: 1.2, // Menos curvatura, más natural
        autoRotate: false,
      },
      duration: 45, // Aún más lento
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".bottom-centered-image",
        start: "top bottom",
        end: "center center",
        scrub: 9, // Ultra controlado con el scroll
      },
    });
  });
  </script>
  
  <style scoped>
  .full-background-section {
    width: 100%;
    height: 130vh;
    background-image: url('../assets/periogard/fondo.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  
  /* Texto superior centrado */
  .top-centered-text {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    font-family: 'ColgateReady-Heavy';
    font-size: 33px;
    font-weight: 900;
    line-height: 25px;
    color: #0E3C88;
    text-align: center;
    text-transform: uppercase;
  }
  
  /* Imagen principal (Diente.png) */
  .right-image {
    position: absolute;
    top: 160px;
    right: 40px;
    width: 50%;
    height: auto;
  }
  
  /* Imágenes encima de Diente.png */
  .right-image-1 {
    top: 160px;
    right: 320px;
    width: 30%;
  }
  
  .right-image-2 {
    top: 160px;
    right: 390px;
    width: 25%;
  }
  
  .right-image-3 {
    top: 160px;
    right: 224px;
    width: 40%;
  }
  
  @keyframes breathing {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1); /* Crece un 8% para más intensidad */
    }
    100% {
      transform: scale(1);
    }
  }
  
  .right-image-1,
  .right-image-2,
  .right-image-3,
  .left-image {
    animation: breathing 4s infinite ease-in-out; /* Más lento y más suave */
  }
  
  
  /* Texto alineado a la izquierda */
  .left-text {
    position: absolute;
    top: 160px;
    left: 60px;
    font-family: 'ColgateReady-Regular';
    font-size: 25px;
    font-weight: 200;
    line-height: 27px;
    color: #0E3C88;
    text-align: left;
  }
  
  /* Texto especial en negrita */
  .bold-text {
    font-weight: 1000;
    font-family: 'ColgateReady-Heavy';
  }
  
  /* Imagen al lado izquierdo, centrada verticalmente */
  .left-image {
    position: absolute;
    left: 0px;
    top: 30%;
    transform: translateY(-50%);
    width: 47%;
    height: auto;
  }
  
  /* Imagen al lado derecho, centrada verticalmente */
  .right-side-image {
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
    width: 47%;
    height: auto;
    padding-top: 195px;
  }
  
  /* Imagen debajo de Texto 3_1.png */
  .bottom-right-image {
    position: absolute;
    right: 60px;
    top: calc(50% + 150px);
    width: 47%;
    height: auto;
  }
  
  /* Nueva imagen centrada horizontalmente tocando el borde inferior */
  .bottom-centered-image {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%; /* Ajusta al tamaño que quieras */
    height: auto;
  }
  </style>
  